// Pseudonimização de MSISDN (o número do cliente) — a "única adaptação de plataforma" da proposta TIM,
// requisito de LGPD. O número em claro NUNCA sai do navegador: o SDK deriva um pseudônimo estável na
// ORIGEM e usa ele como user_id. Esquema IDÊNTICO ao sdk-py (mesmo pseudônimo em browser e server, p/
// a resolução de identidade casar). Agnóstico (REGRA #1): serve qualquer número, não só MSISDN.
//
//   pseudonym = prefix + sha256_hex( salt + ":" + normalize(msisdn) )[:32]
//
// O `salt` é por-tenant (rainbow-table + não-linkável entre tenants) e vem na config do SDK.

/** Normaliza o número p/ um pseudônimo estável: só dígitos, sem prefixo de tronco, com país opcional. */
export function normalizeMsisdn(raw, countryCode = "") {
  let d = String(raw == null ? "" : raw).replace(/\D/g, "");
  d = d.replace(/^0+/, "");                                  // remove zeros de tronco à esquerda
  if (countryCode && !d.startsWith(countryCode)) d = countryCode + d;
  return d;
}

async function sha256Hex(str) {
  if (typeof crypto !== "undefined" && crypto.subtle) {
    const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(str));
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
  }
  throw new Error("Web Crypto (crypto.subtle) indisponível — não é possível pseudonimizar com segurança");
}

/**
 * Deriva o pseudônimo do número. Assíncrono (Web Crypto). Retorna null se o número for vazio.
 * @param {string} raw  o número em claro (fica SÓ na memória; nunca é enviado)
 * @param {{salt?:string, countryCode?:string, prefix?:string}} [o]
 */
export async function pseudonymizeMsisdn(raw, o = {}) {
  const { salt = "", countryCode = "", prefix = "msi_" } = o;
  const norm = normalizeMsisdn(raw, countryCode);
  if (!norm) return null;
  const hex = await sha256Hex(`${salt}:${norm}`);
  return prefix + hex.slice(0, 32);
}
